// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__b14 {
  .vendorInput__c44 {
    width: calc(var(--ring-unit) * 44.25);
  }

  .vendorSelector__d6f + .actionSelector__edf {
    margin-top: calc(var(--ring-unit) * 2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/vendor-plugins-rule/vendor-plugins-rule.css"],"names":[],"mappings":"AAAA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sCAAsC;EACxC;AACF","sourcesContent":[".wrapper {\n  .vendorInput {\n    width: calc(var(--ring-unit) * 44.25);\n  }\n\n  .vendorSelector + .actionSelector {\n    margin-top: calc(var(--ring-unit) * 2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__b14`,
	"vendorInput": `vendorInput__c44`,
	"vendorSelector": `vendorSelector__d6f`,
	"actionSelector": `actionSelector__edf`
};
export default ___CSS_LOADER_EXPORT___;
